import React from 'react';

export default class GameBoard extends React.Component {

  constructor(props, context) {
    super(props, context);
  }

  render() {
    const tiles = this.props.getTiles();
    const bgImage = this.props.bgImage;
    const style = {backgroundImage: `url(${bgImage})`};
    return(
      <div className="game-board">
        <div
          style={style}
          className="game-board__picture"></div>
        <div className="game-board__board">
          {tiles}
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/hidden-picture/game-board.js
 **/